// Step URL mapping and navigation utilities
export const stepUrls = [
  'info_dasar',
  'target_pengguna',
  'syarat_penggunaan',
  'ketentuan_produk',
] as const;

export type StepUrl = (typeof stepUrls)[number];

/**
 * Convert URL step name to step index
 */
export const getStepIndexFromUrl = (stepUrl: string | null): number => {
  if (!stepUrl) return 0;
  const index = stepUrls.indexOf(stepUrl as StepUrl);
  return index >= 0 ? index : 0;
};

/**
 * Convert step index to URL step name
 */
export const getUrlFromStepIndex = (stepIndex: number): string | null => {
  return stepUrls[stepIndex] || null;
};
